<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h2 class="purple bold">Visualizar evento</h2>
      </b-col>
    </b-row>

    <b-row class="teacher-profile mt-50">
      <b-col>
        <b-row>
          <b-col>
            <b-form-group class="required" description>
              <label for="label">Título</label>
              <b-form-input
                v-model="event.title"
                type="text"
                placeholder
                required
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="required" description>
              <label for="label">Disponível até</label>
              <b-form-input
                v-model="event.available_until"
                type="date"
                required
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col class="text-left" v-if="event.attachment_url">
            <b-form-group description>
              <label required for="label text-left">Anexo</label>
              <div class="wrap-button">
                <b-col class="text-left">
                  <a
                    target="_blank"
                    :href="event.attachment_url"
                    class="upload btn"
                    >Acessar anexo</a
                  >
                </b-col>
              </div>
            </b-form-group>
          </b-col>

          <b-col class="text-left" v-else>
            <b-form-group description>
              <label required for="label text-left">Anexo</label>
              <b-form-input
                v-model="event.attachment_url"
                type="text"
                placeholder="Sem anexo"
                required
                disabled
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-8">
            <b-form-group class="required" description>
              <label for="label">Descrição</label>
              <b-form-textarea
                v-model="event.description"
                type="textarea"
                placeholder
                required
                disabled
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col class="col-4">
            <b-form-group
              class="required"
              label="Precisa de autorização dos responsáveis?"
              description
              disabled
            >
              <b-form-radio-group v-model="event.auth_is_required">
                <b-form-radio value="true" placeholder>Sim</b-form-radio>
                <b-form-radio value="false" placeholder required
                  >Não</b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <targets :data="event" />
      </b-col>
    </b-row>

    <b-row align-v="center" class="mt-5">
      <b-col class="text-left">
        <b-button @click="sendNotifications" class="large blue"
          >Enviar notificações</b-button
        >
      </b-col>
      <b-col class="text-right">
        <b-button
          class="large blue outline"
          :to="{
            name: 'eventos',
          }"
          >Voltar</b-button
        >

        <b-button @click="generateReport" class="large blue"
          >Gerar relatório</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import httpRda from "../../../http-rda.js";
import Targets from "../../../components/Targets.vue";
import moment from "moment";

export default {
  name: "updateEvent",
  components: { Targets },

  data() {
    return {
      formFilled: false,
      event: null,
      attachment: null,
      file: null,

      breadcrumb: [
        {
          text: "Administração",
          href: "/administracao",
        },
        {
          text: "Eventos",
          href: "/administracao/eventos",
        },
        {
          text: "Visualizar evento",
          href: "showEvent",
          active: true,
        },
      ],
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
  },

  methods: {
    getEvent() {
      httpRda.get(`events/${this.id}`).then((response) => {
        this.event = response.data.event;
      });
    },

    async sendNotifications() {
      this.$swal
        .fire({
          title: "Tem certeza que deseja notificar os destinatários?",
          text: "Todos os usuários selecionados com acesso ao app serão notificados!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#68c5b7",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sim",
          cancelButtonText: "Cancelar",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              await httpRda.post("/send-notifiables", {
                resource_name: "Event",
                resource_id: this.id,
                target_name: "User",
              });

              const Toast = this.$swal.mixin({
                toast: true,
                position: "bottom-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "success",
                title: `Notificações enviadas aos destinatários!`,
              });
            } catch (error) {
              this.$swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Não foi possivel enviar as notificações!",
                footer: "Por favor, tente novamente mais tarde.",
              });
            }
          }
        })
        .catch((error) => {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Não foi possivel notificar!",
            footer: "Por favor, tente novamente mais tarde.",
          });

          return error;
        });
    },

    async generateReport() {
      try {
        const response = await httpRda.get(`events/${this.id}/report`, {
          responseType: "blob",
        });

        const date = moment().format("DD-MM-YYYY-HH:mm:ss").toString();

        const newBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob);
          return;
        }

        let data = window.URL.createObjectURL(newBlob);
        const link = document.createElement("a");
        link.href = data;
        link.download = `Relatorio_Evento_${this.event.title}_${date}`;
        link.click();

        setTimeout(function () {
          window.URL.revokeObjectURL(data);
        }, 100);

        const Toast = this.$swal.mixin({
          toast: true,
          position: "bottom-end",
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.addEventListener("mouseenter", this.$swal.stopTimer);
            toast.addEventListener("mouseleave", this.$swal.resumeTimer);
          },
        });

        Toast.fire({
          icon: "success",
          title: `Relatório exportado com sucesso!`,
        });

        return response;
      } catch (error) {
        this.loadText = "Exportar";
        this.subjectsSelected = [];

        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Não foi possivel exportar o relatório!",
          footer: "Por favor, tente novamente mais tarde.",
        });

        return error;
      }
    },
  },

  created() {
    this.getEvent();
  },
};
</script>

<style lang="scss">
.teacher-profile {
  .form-group {
    &.required {
      &:after {
        right: 0;
      }
    }
  }
}

.title-collapse {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  h5 {
    flex: 1;
  }

  .btn {
    background: transparent;
    border: 0;

    svg {
      font-size: 16px;
      fill: red;
    }
  }
}

.table-students {
  width: 100%;

  td,
  th {
    font-size: 18px;
    width: 50%;
  }

  th {
    padding-bottom: 20px;
  }

  td {
    padding: 20px 0;
  }

  tr + tr {
    border-bottom: 1px solid $grey5;
  }
}

.student-responsible {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;

  span {
    background-color: #efefef;
    padding: 4px 8px;
    border-radius: 4px;
    box-sizing: border-box;
  }
}

.wrap-tags {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;

  span {
    background-color: #efefef;
    padding: 4px 8px;
    border-radius: 4px;
    box-sizing: border-box;
  }
}

.wrap-button {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  background-color: #68c5b7;
  border-radius: 5px;
  color: #ffffff;
  font-weight: 700;
  line-height: 28px;
  margin: 3px 12px 3px 0;
  padding: 0 3px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
  vertical-align: middle;
  max-width: 100%;
}

.container-rda .multiselect__tag-icon:after {
  color: white;
}

input.isInvalid {
  border-color: red;
}
</style>
